import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogService } from '@kodit/core/shared-ui';
import { DialogSize } from 'libs/core/shared-ui/src/lib/dialogs/dynamic-dialog/dynamicdialog-config';
import { Subscription } from 'rxjs';
import { EotpremnicaFormService, StrankaOtpremniceForm } from '../../otpremnice/eotpremnica-form.service';
import { IEOtpremnicaDto, IStrankaOtpremniceDto, NacinOtpreme, RacuniClient, TipStranke } from '@kodit/core/data-api';
import { ActivatedRoute } from '@angular/router';
import { FormGroupTypeSafe } from 'angular-typesafe-reactive-forms-helper';
import { FormArray } from '@angular/forms';

@Component({
  selector: 'kodit-stranka-prevoznik-faze',
  templateUrl: './stranka-prevoznik-faze.component.html',
  styleUrls: ['./stranka-prevoznik-faze.component.scss']
})
export class StrankaPrevoznikFazeComponent implements OnInit, OnDestroy {

 /** Configs */
  dialogConfig: DynamicDialogConfig = new DynamicDialogConfig(DialogSize.LARGE);

  /** Props */
  private _subs: Subscription = new Subscription();
  nazivNepronadjeneStranke: string;
  fizickoLiceTip = TipStranke.FIZIKO_LICE;
  fizickoLiceNaziv: string;
  isFirstLoad: boolean = true;

  jeInostranoPravnoLice: boolean;
  form: StrankaOtpremniceForm;

  /** I/O */
  @Input() otpremnicaFormGroup: FormGroupTypeSafe<IEOtpremnicaDto>;
  @Input() index: number;

  constructor(
    private _otpremnicaService: EotpremnicaFormService,
    private _route: ActivatedRoute,
    private _dialogService: DynamicDialogService,
    private _clientRacun: RacuniClient,
    //private _strankaRacunaFormService: StrankaRacunaFormService
  ) {}

  ngOnInit(): void {
    this.setStranka();

    // this._subs.add(
    //   this._racunService.getShowFizickoLiceCreate.subscribe((res) => {
    //     this.nazivNepronadjeneStranke = res;
    //   })
    // );
    // if (
    //   this._route.snapshot.data.racun?.racunDto?.strankaRacunaDto
    //     ?.tipStranke === TipStranke.FIZIKO_LICE &&
    //   !this._route.snapshot.data.racun?.racunDto?.strankaRacunaDto?.id
    // ) {
    //   this._racunService.setPerformSearchFizickogLica = this.racunFormGroup.value.strankaRacunaDto?.naziv;
    // }
  }

  onSelectionChange(stranka: IStrankaOtpremniceDto) {
    this._otpremnicaService.setStrankaPrevoznikFaze(stranka, this.index);

    if (stranka.id) {
      this.jeInostranoPravnoLice =
        stranka.registracioniBroj != undefined &&
        stranka.registracioniBroj != null;
    }
  }

  setStranka() {
    this.form = this._otpremnicaService.getStrankaPrevoznikFazaFormGroup(this.index);
    // if(this._otpremnicaService.jeEdit)
    // {
    //   return;
    // }
    if(!this._otpremnicaService.jeEdit) {

      if (this._otpremnicaService.nacinOtpremeSubject.value == NacinOtpreme.SOPSTVENI_PREVOZ) {
        this._subs.add(
          this._clientRacun
            .searchStrankaRacuna(null, true)
            .subscribe((res) => {
              if (res.succeeded) {
                this._otpremnicaService.setStrankaPrevoznikFaze(res.data?.strankaRacunaDtoList?.[0], this.index);
              }
            })
        );
      } else if (this._otpremnicaService.nacinOtpremeSubject.value == NacinOtpreme.PREVOZ_PRIMAOCA) {
        const prevoznik = this._otpremnicaService.getStrankaEOtpremniceFormGroup.value;
        this._otpremnicaService.setStrankaPrevoznikFaze(prevoznik, this.index);

      }
    }
    // this.jeInostranoPravnoLice =
    //   this.form.controls.registracioniBroj.value != undefined &&
    //   this.form.controls.registracioniBroj.value != null;
  }

  onSelectionClear() {
    const fazeVoznje = this.otpremnicaFormGroup.get('fazeVoznjeDto') as FormArray;

    if (fazeVoznje && fazeVoznje.at(this.index)) {
      fazeVoznje.at(this.index).get('prevoznikDto')?.reset();
    }
  }

  handleCreateFizickoLice() {
    this.dialogConfig.header = 'Unos fizičkog lica';

    const nazivFizickoLica = this.otpremnicaFormGroup.value.strankaDto.naziv
      ? this.otpremnicaFormGroup.value.strankaDto.naziv.split(' ')
      : this.fizickoLiceNaziv?.split(' ') ?? [''];
    this.dialogConfig.data = {
      ime: nazivFizickoLica[0],
      prezime: nazivFizickoLica
        .filter((x) => x != nazivFizickoLica[0])
        .join(' '),
      grad: this.otpremnicaFormGroup.value.strankaDto?.adresa,
    };

    this.openDialog(this.dialogConfig);
    //this._racunService.setShowFizickoLiceCreate = null;
  }

  handleNazivChange(naziv: string) {
    this.fizickoLiceNaziv = naziv;
  }

  openDialog(config: DynamicDialogConfig) {
    // const ref = this._dialogService.open(FizickoLiceFormComponent, config);

    // this._subs.add(
    //   ref.onClose.subscribe((result: ResultOfFizickoLiceVm) => {
    //     if (result) {
    //       this.racunFormGroup.controls.strankaRacunaDto.patchValue({
    //         id: result.data.fizickoLiceDto.id,
    //         naziv: result.data.fizickoLiceDto.naziv,
    //         adresa: result.data.fizickoLiceDto.adresa.punaAdresa,
    //         mb: result.data.fizickoLiceDto.jmbg,
    //         tipStranke: TipStranke.FIZIKO_LICE,
    //         rokPlacanjaZaIzlazne:
    //           result.data.fizickoLiceDto.rokPlacanjaZaIzlazne,
    //         rokPlacanjaZaUlazne: result.data.fizickoLiceDto.rokPlacanjaZaUlazne,
    //       });
    //     }
    //   })
    // );
  }

  get fazeVoznje(): FormArray {
    return this.otpremnicaFormGroup?.get('fazeVoznjeDto') as FormArray;
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }

}
